/**
 * TYR Gallery Fit — Round 7
 *
 * Dynamically caps the product gallery's slide height so the thumbnail
 * strip is always fully visible in the first viewport, replacing the
 * static viewport-offset math from Rounds 4/6 (which broke whenever a
 * real browser differed from the assumed constants — the live header
 * renders ~112px tall, not the 60px the --header-height variable
 * claims, and short viewports hit the 420px min-height floor).
 *
 * Measures, on load and on resize:
 *   - the gallery's natural top offset in the document (captures the
 *     real header height AND the section padding, whatever they are)
 *   - the real rendered height of the thumbnail strip
 * then sets --tyr-gallery-cap on the media-gallery element. The CSS in
 * custom-tyr.css consumes it via var(--tyr-gallery-cap, <static
 * fallback>), so with JS unavailable the Round 6 static formula still
 * applies.
 *
 * The measured inputs are independent of the output (thumbnails are
 * fixed 64px squares, the gallery's top offset depends only on what
 * sits above it), so there is no feedback loop.
 *
 * Desktop only: below 750px Horizon uncaps slide heights and overlays
 * dot controls on the media, so there is nothing to keep in view.
 */
(function () {
  var MIN_CAP = 280; // never squash the hero below this, even on tiny windows
  var SAFETY = 12; // breathing room under the strip

  function fit() {
    var wrapper = document.querySelector('.product-information__media');
    var gallery = wrapper && wrapper.querySelector('media-gallery');
    if (!gallery) return;

    if (window.innerWidth < 750) {
      gallery.style.removeProperty('--tyr-gallery-cap');
      return;
    }

    var strip = gallery.querySelector('slideshow-controls[thumbnails]:not([controls-on-media])');
    var stripHeight = strip ? strip.getBoundingClientRect().height : 0;

    // Natural offset of the gallery from the top of the page. Horizon
    // scrolls a .page-wrapper div, NOT the window — window.scrollY is
    // always 0 on this theme — so the scroll position must come from
    // the wrapper's scrolling ancestor for this to be stable at any
    // scroll depth (e.g. a resize that fires mid-scroll).
    var scroller = wrapper.closest('.page-wrapper') || document.scrollingElement;
    var scrollTop = scroller ? scroller.scrollTop : window.scrollY;
    var naturalTop = wrapper.getBoundingClientRect().top + scrollTop;

    var cap = Math.max(MIN_CAP, window.innerHeight - naturalTop - stripHeight - SAFETY);
    gallery.style.setProperty('--tyr-gallery-cap', Math.round(cap) + 'px');
  }

  var pending;
  function queueFit() {
    clearTimeout(pending);
    pending = setTimeout(fit, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fit);
  } else {
    fit();
  }
  // Re-measure once everything (fonts, header logo) has loaded, and on
  // any viewport change.
  window.addEventListener('load', fit);
  window.addEventListener('resize', queueFit);

  // Header height can change after fonts/menu settle; the strip can
  // change if media changes. Watch both.
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(queueFit);
    var header = document.querySelector('header-component');
    if (header) ro.observe(header);
    var strip = document.querySelector(
      '.product-information__media slideshow-controls[thumbnails]:not([controls-on-media])'
    );
    if (strip) ro.observe(strip);
  }

  // If a variant change ever swaps the media-gallery element (it does
  // not for this product — no per-variant media — but belt and braces),
  // re-apply the cap to the new element.
  var wrapper = document.querySelector('.product-information__media');
  if (wrapper && 'MutationObserver' in window) {
    new MutationObserver(queueFit).observe(wrapper, { childList: true });
  }
})();
